import { useState } from "react";
import { createPortal } from "react-dom";
import { X, ZoomIn } from "lucide-react";

// Full-screen high-res image viewer with tap-to-zoom (1x ↔ 2.5x) + drag/scroll.
export function ImageZoom({ src, alt, onClose }) {
  const [zoom, setZoom] = useState(1);
  return createPortal(
    <div data-testid="image-zoom-overlay" className="fixed inset-0 z-[90] bg-black/95 flex flex-col" onClick={onClose}>
      <div className="flex items-center justify-between px-4 py-3 text-white shrink-0" style={{ paddingTop: "calc(env(safe-area-inset-top) + 12px)" }}>
        <span className="text-sm font-semibold flex items-center gap-2"><ZoomIn className="w-4 h-4" /> Tap image to zoom</span>
        <button data-testid="image-zoom-close" onClick={onClose} className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center active:scale-90"><X className="w-5 h-5" /></button>
      </div>
      <div className="flex-1 overflow-auto flex items-center justify-center p-2" onClick={(e) => e.stopPropagation()}>
        <img data-testid="image-zoom-img" src={src} alt={alt || ""} onClick={() => setZoom((z) => (z === 1 ? 2.5 : 1))}
          style={{ transform: `scale(${zoom})`, transformOrigin: "center", transition: "transform 0.25s ease", cursor: zoom === 1 ? "zoom-in" : "zoom-out", touchAction: "pinch-zoom" }}
          className="max-w-full max-h-full object-contain select-none" />
      </div>
    </div>,
    document.body
  );
}
